export const engagementLinkTemplatesTerritories = "/engagement/link_templates/territories";
